<template>
  <div class="list-group-item flex-column align-items-start main-item">
    <div class="d-flex w-100 justify-content-between">
      <div class="brand d-flex justify-content-between align-items-center">
        <img :src="getSymbolImageSrc(assetName)" class="icon-symbol" v-show="getSymbolImageSrc(assetName)"/>
        <div
          class="text d-flex flex-column justify-content-around ml-3 asset-wrapper"
        >
          <h6>{{ visualAssentName }}</h6>
          <small :class="visualPrice(price, 'percentColor')">{{
            visualPrice(price, "percentValue")
          }}</small>
        </div>
      </div>
      <div class="buttons d-flex justify-content-around trade-btns">
        <button class="btn ripple-button" @click.prevent="clickOnAction">
          <div class="text">{{ t("Assets_Sell") }}</div>
          <div class="price" :class="visualPrice(price, 'cb')">
            {{ visualPrice(price, "b", "d") }}
          </div>
        </button>
        <button class="btn ripple-button" @click.prevent="clickOnAction">
          <div class="text">{{ t("Assets_Buy") }}</div>
          <div class="price" :class="visualPrice(price, 'ca')">
            {{ visualPrice(price, "a", "d") }}
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { scrollToForm } from "@/utils/general";
import { visualPrice } from "@/utils/symbolsSocket";

export default {
  name: "singleRelatedItem",
  props: ["assetName", "price"],
  computed: {
    ...mapState(["isLoggedIn"]),
    ...mapGetters([
      "chartInstrumentDeepLink",
      "getSymbolImageSrc",
      "t",
      "userSignupLink"
    ]),
    visualAssentName: function() {
      if (
          this.assetName.length <= 8 ||
        window.matchMedia("(max-width: 769px)").matches
      ) {
        return this.assetName;
      } else {
        return this.assetName.slice(0, 7) + "..";
      }
    }
  },
  methods: {
    visualPrice: visualPrice,
    clickOnAction() {
      if (this.isLoggedIn) {
        const that = this;
        setTimeout(function() {
          //to allow ripple effect to complete //todo: make alternative solution with css instead!
          window.location.href = that.chartInstrumentDeepLink(that.assetName);
        }, 400);
      } else {
        scrollToForm();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.list-group-item {
  .btn-outline-secondary:hover {
    background: inherit;
  }
  .icon-symbol {
    width: 24px;
    height: 24px;
  }
  .buttons .btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 500;
    width: 5rem;
    border: 1px solid #7a7c7c;
    background-position: center;
    transition: background 0.8s;
    padding: 4px 0;

    .text {
      font-size: 1rem;
      color: #424242;
    }
    .price {
      font-size: 0.875rem;
    }
    &:focus {
      box-shadow: none;
      border: 1px solid #424242;
      border-radius: 0.25rem;
    }
    &:hover {
      background-color: #1c79be;
      border: none;
      div {
        color: #ffffff;
      }
    }
    /*old ripple effect*/
    //&:hover{
    //  background: #ffffff radial-gradient(circle, transparent 1%, #ffffff 1%) center/15000%;
    //}
    //&:active {
    //  background-color: #1c79be;
    //  background-size: 100%;
    //  transition: background 0s;
    //}
    /*end of old ripple effect*/
    &:first-of-type {
      margin-right: 1rem;
    }
  }
}

.ar {
  .list-group-item {
    .brand {
      .ml-3 {
        margin: 0 1rem 0 0;
      }
    }
    .buttons .btn {
      &:first-of-type {
        margin: 0 0 0 1rem;
      }
    }
  }
}
.es,
.de {
  .list-group-item {
    .buttons .btn {
      .text {
        font-size: 0.875rem;
      }
    }
  }
}
.de {
  .list-group-item {
    .buttons .btn {
      width: 5.5rem;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1100px) {
  .list-group-item {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    .asset-wrapper {
      margin-left: 6px !important;
      h6 {
        font-size: 0.875rem;
      }
    }
    .trade-btns button {
      width: 50px;
      padding-right: 0px;
      padding-left: 0px;
      margin-right: 4px !important;
      font-size: 0.875rem;
    }
  }
}
@media only screen and (min-width: 768px) and (max-width: 830px) {
  .list-group-item {
    padding-right: 3px;
    padding-left: 3px;
    .asset-wrapper {
      margin-left: 6px !important;
    }
    .trade-btns button {
      width: 40px;
      left: 2px !important;
      font-size: 0.875rem;
    }
  }
}
@media only screen and (max-width: 768px) {
  .main-item {
    .asset-wrapper {
      margin-left: 15px !important;

      h6 {
        font-size: 0.875rem;
      }

      small {
        font-size: 0.75rem;
        //color: #9E9E9E;
      }
    }
  }
}
</style>
